/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface NotFoundErrorResult
 */
export interface NotFoundErrorResult {
    /**
     * 
     * @type {ResultStates}
     * @memberof NotFoundErrorResult
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof NotFoundErrorResult
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof NotFoundErrorResult
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof NotFoundErrorResult
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof NotFoundErrorResult
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof NotFoundErrorResult
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof NotFoundErrorResult
     */
    validationErrors: { [key: string]: Array<string>; };
}

/**
 * Check if a given object implements the NotFoundErrorResult interface.
 */
export function instanceOfNotFoundErrorResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;

    return isInstance;
}

export function NotFoundErrorResultFromJSON(json: any): NotFoundErrorResult {
    return NotFoundErrorResultFromJSONTyped(json, false);
}

export function NotFoundErrorResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotFoundErrorResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
    };
}

export function NotFoundErrorResultToJSON(value?: NotFoundErrorResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
    };
}

